<template>
  <div class="jps-card">
    <div class="jps-card-img">
      <div class="card-image">
        <slot name="image" />
      </div>
    </div>
    <div class="jps-card-body" :class="`height-${height}`">
      <h3 class="jps-card-title">
        <slot name="title" />
      </h3>
      <div class="scroll-content">
        <div class="jps-card-owner empty-hide">
          <slot name="owner" />
        </div>
        <div class="jps-card-record-count empty-hide">
          <slot name="record-count" />
        </div>
        <div class="jps-card-content empty-hide">
          <slot />
        </div>
      </div>
    </div>
    <div class="jps-card-icon empty-hide">
      <slot name="interact" />
    </div>
  </div>
</template>

<script lang="ts" setup>
interface Props {
  height?: 'auto' | 'middle'
}
withDefaults(defineProps<Props>(), {
  height: 'auto',
})
</script>

<style lang="scss" scoped>
@use '@/assets/styles/scss/vue' as *;

.jps-card {
  .jps-card-img {
    transform: translateZ(0);
  }
  .jps-card-body {
    .jps-card-title {
      :deep(> *) {
        padding: 0.75rem 0.75rem 1rem;
        font-size: 1rem;
        font-weight: bolder;
        line-height: 145%;
        display: block;
        position: relative;
        overflow-wrap: break-word;
        text-align: left;
      }
    }
    .scroll-content {
      overflow-y: scroll;
      @include no-scrollbar();

      .jps-card-content {
        &, :deep(p) {
          line-height: 1.3125rem;
        }
      }
    }
  }

  .jps-card-icon {
    > * {
      @include is-mobile {
        margin-top: -1rem;
        padding-top: 0;
        background-image: none;
      }
    }
  }

  &:hover {
    > * {
      background-image: none;
    }
  }
}

.empty-hide {
  &:empty { display: none; }
}

.height-middle {
  height: 8rem;
}

.height-auto {
  @include is-tablet {
    min-height: 8rem;
  }
}
</style>
